export default {"src":"/_next/static/media/icon-empowerment.8e1b1713.svg","height":90,"width":90,"blurWidth":0,"blurHeight":0};